import React from 'react';
import styled from 'styled-components';

const firstSectionContent = [
 'Define your targets',
 'Identify your fulfillment partners',
 'Create an Action Plan as per PWM Format',
 'Apply for a PWM Registration at CPCB',
 'Start fulfilling EPR targets',
 'Quarterly filing ',
];

const secondSectionContent = [
 'Guidelines on EPR',
 'Centralized Extended Producers Responsibility Portal for Plastic Packaging',
 'Plastic Waste Management Rules, 2016, as amended, 2021',
 'Sample District Environment Plan',
 'Draft Notification on Extended Producer Responsibility (EPR)',
 'PWM Rules',
 'EPR Authorization under E-Waste Management Rules',
 'Pollution Control Acts, Rules and Notification',
 'Plastic Waste Management Rules, 2016, as amended, 2018',
 'Notice for Producers regarding  E-waste Management',
];

export default function LastSection() {
 return (
  <Container>
   <Wrapper>
    <Firstsection>
     <div className='header'>
      <Heading>Steps for EPR fulfillment for Plastic Waste</Heading>
      <Linebreak>
       <div className='part1'></div>
       <div className='part2'></div>
       <div className='part3'></div>
      </Linebreak>
     </div>
     <Firstsectioncontent>
      {firstSectionContent.map((val, index) => {
       return (
        <FirstContainer
         text={val}
         index={index + 1}
         key={`first-${index}`}
        ></FirstContainer>
       );
      })}
     </Firstsectioncontent>
    </Firstsection>
    <Secondsection>
     <h3>
      Central Government Rules Regarding Extended Producer Responsibility:
     </h3>
     <Secondsectioncontent>
      {secondSectionContent.map((val, index) => {
       return <SecondContainer text={val} key={index} />;
      })}
     </Secondsectioncontent>
    </Secondsection>
   </Wrapper>
   <Triangle />
  </Container>
 );
}

function FirstContainer({ text, index }) {
 return (
  <Firstwrapper>
   <p>{text}</p>
   <section>
    <div>
     <p>Step {index}</p>
    </div>
   </section>
  </Firstwrapper>
 );
}

function SecondContainer({ text }) {
 return <Secondwrapper>{text}</Secondwrapper>;
}

const Container = styled.div`
 position: relative;
 width: 100%;
 height: auto;
 background: #fff;
 z-index: 2rem;
`;

const Wrapper = styled.div`
 display: flex;
 align-items: center;
 flex-direction: column;
 width: 90%;
 margin: 0 auto;
 padding: 5rem;
 gap: 5rem;
 z-index: 2;
`;

const Triangle = styled.div`
 position: absolute;
 background: #90d62b;
 top: 0;
 right: 0;
 height: 70%;
 width: 30%;
 clip-path: polygon(0 0, 100% 100%, 0 100%);
 transform: rotate(180deg);
`;

const Firstsection = styled.div`
 width: 50%;
 margin: 0 auto;
 @media screen and (max-width: 600px) {
  width: 100%;
 }
`;
const Secondsection = styled.div`
 width: 90%;
 margin: 0 auto;
 @media screen and (max-width: 600px) {
  width: 100%;
 }
`;
const Firstsectioncontent = styled.div`
 display: grid;
 grid-template-columns: repeat(3, 1fr);
 padding-top: 3rem;
 gap: 2rem 3rem;
 section {
  width: 6rem;
  height: 6rem;
  border-radius: 2rem 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  background: #90d62b;
  color: #fff;
  div {
   position: relative;
   width: 100%;
   height: 100%;
   overflow: hidden;
   p {
    position: absolute;
    top: 1rem;
    left: 0;
    font-weight: 600;
    text-transform: capitalize;
    font-size: 1.2rem;
    transform: rotate(-45deg);
   }
   &::after {
    position: absolute;
    top: 30%;
    left: 30%;
    content: '';
    width: 141%;
    height: 141%;
    background: linear-gradient(135deg, #f2f2f2 0%, #ffffff 100%);
    transform-origin: center;
    transform: rotate(45deg);
   }
  }
 }
`;
const Secondsectioncontent = styled.div`
 display: grid;
 grid-template-columns: repeat(5, 1fr);
 padding-top: 3rem;
 gap: 2rem 3rem;
 @media screen and (max-width: 600px) {
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
 }
`;

const Heading = styled.h1`
 font-size: 2.5rem;
 font-weight: 600;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #444444;
`;

const Linebreak = styled.div`
 width: 20%;
 display: flex;
 gap: 0.5rem;
 margin: -1rem auto 0 auto;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Firstwrapper = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
 height: 15rem;
 border-radius: 1.5rem;
 color: #707070;
 font-size: 1.5rem;
 z-index: 200;
 > p {
  z-index: 2;
  font-size: 1.5rem;
  font-weight: 600;
  color: #707070;
 }
 background: linear-gradient(135deg, #f2f2f2 0%, #ffffff 100%);
 box-shadow: 3px -6px 10px rgba(224, 224, 224, 0.2),
  5px -5px 10px rgba(224, 224, 224, 0.2),
  -5px -5px 10px rgba(255, 255, 255, 0.9), 5px 5px 13px rgba(224, 224, 224, 0.9),
  inset 1px 1px 2px rgba(255, 255, 255, 0.3),
  inset -1px -1px 2px rgba(224, 224, 224, 0.5);
`;
const Secondwrapper = styled.div`
 border-radius: 1rem;
 padding: 1rem;
 display: flex;
 align-items: center;
 justify-content: center;
 color: #444444;
 font-size: 1rem;

 background: linear-gradient(135deg, #ffffff 0%, #ededed 100%);
 box-shadow: -3.7917px 3.7917px 7.5834px rgba(221, 221, 221, 0.2),
  3.7917px -3.7917px 7.5834px rgba(221, 221, 221, 0.2),
  -3.7917px -3.7917px 7.5834px rgba(255, 255, 255, 0.9),
  3.7917px 3.7917px 9.85842px rgba(221, 221, 221, 0.9),
  inset 0.75834px 0.75834px 1.51668px rgba(255, 255, 255, 0.3),
  inset -0.75834px -0.75834px 1.51668px rgba(221, 221, 221, 0.5);
`;
